import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-careonline-today',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './careonline-today.component.html',
  styleUrls: ['./careonline-today.component.scss']
})
export class CareonlineTodayComponent implements OnInit, OnChanges {

  @Input('title') title: string = 'GigSumo Today ';
  headerTitle: string = 'GigSumo Today ';
  user: any = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
  @Input() maxMin: any = {};
  @Input() page: string;
  @Input() inputData: string;
  viewType: string = "MIN";
  @Input() widgetDesc: string;
  @Input() suggestion: any;

  constructor( private router: Router,private a_route: ActivatedRoute) {
   }

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'GigSumo Today';
    dataPass.masterMenu =  this.inputData;
    dataPass.widgetName = "CareonlineTodayComponent";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {
      if(res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
        this.headerTitle=res.menu;
      }
   })
  }

}
